import React from 'react';
import { IconButton, Paper, Skeleton, Stack } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const skeletonStyles = {
    rounded: { height: 50, borderRadius: '16px' },
};

const GhostMailPill = () => {
    return (
        <Paper
            sx={{
                mb: 5,
                p: 2,
                boxShadow: 'none',
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ flexWrap: 'wrap', justifyContent: 'space-between' }}
            >
                <Skeleton
                    variant="rounded"
                    sx={{ width: 120, ...skeletonStyles.rounded }}
                />

                <Skeleton
                    variant="rounded"
                    sx={{ width: 500, ...skeletonStyles.rounded }}
                />

                <Skeleton
                    variant="rounded"
                    sx={{ width: 140, ...skeletonStyles.rounded }}
                />
                <Skeleton
                    variant="rounded"
                    sx={{ width: 140, ...skeletonStyles.rounded }}
                />
                <Skeleton
                    variant="rounded"
                    sx={{ width: 140, ...skeletonStyles.rounded }}
                />
                <Skeleton
                    variant="rounded"
                    sx={{ width: 110, height:30, borderRadius: '16px'}}
                />

                <IconButton disabled sx={{ width: 40 }}>
                    <ExpandMoreIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default GhostMailPill;
